import { useDispatch } from "react-redux"
import { logoutSuccessful, } from "../../../redux/slices/userSlice";
import { clearAddresses, clearAllData } from "../../../redux/slices/commonDropdownSlice";
import { clearAllAttendanceData } from "../../../redux/slices/attendanceSlice";
import { clearAllOrgData } from "../../../redux/slices/organizationSlice";
import { clearAllProspects } from "../../../redux/slices/prospectsSlice";
import { clearAllAdminList } from "../../../redux/slices/adminListSlice";
import { clearAllApplication } from "../../../redux/slices/applicationSlice";

export const useUserAction = () => {
    const dispatch = useDispatch();

    const logoutUser = () => {
        // clearing the dropdown
        dispatch(clearAllData("all"));
        dispatch(clearAllAttendanceData());
        dispatch(clearAllOrgData());
        dispatch(clearAllProspects());
        dispatch(clearAddresses());
        dispatch(clearAllAdminList());
        dispatch(clearAllApplication());

        //clearing the userData
        dispatch(logoutSuccessful());
    }




    return {
        logoutUser,

    }
}